// base-button.component.ts
import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonModule} from '@angular/common';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-base-button',
  template: `
    <button
      class="transition-all touch-manipulation"
      [class]="baseClass"
      [ngClass]="{
        'scale-95 !bg-theme-primary-active': active && stateColorScheme === 'primary',
        'scale-95 !bg-theme-surface-active': active && stateColorScheme === 'surface',
        'md:hover:bg-theme-primary-hover': !active && !disabled && stateColorScheme === 'primary',
        'md:hover:bg-theme-surface-hover': !active && !disabled && stateColorScheme === 'surface',
        'opacity-40 cursor-not-allowed': disabled
      }"
      [disabled]="disabled"
      (click)="handleClick($event)"
      (touchstart)="setActive(true)"
      (touchend)="setActive(false)"
      (touchcancel)="setActive(false)">
      <ng-content></ng-content>
    </button>
  `
})
export class BaseButtonComponent implements OnInit {
  @Input() baseClass = '';
  @Input() stateColorScheme: 'primary' | 'surface' = 'primary';
  @Input() disabled = false;
  @Input() blocked = false;
  @Output() onClick = new EventEmitter<MouseEvent>();

  ngOnInit() {
  }

  active = false;

  setActive(b: boolean) {
    if (this.disabled) return;
    this.active = b;
    if (!b) {
      setTimeout(() => {
        this.active = false;
      }, 100);
    }
  }

  handleClick(event: MouseEvent) {
    if (this.disabled || this.blocked) return;
    this.onClick.emit(event);
    setTimeout(() => {
      this.active = false;
    }, 100);
    event.stopPropagation();
  }

}
